import { render } from "./ListeColisPage.vue?vue&type=template&id=1a8b84ce&ts=true"
import script from "./ListeColisPage.vue?vue&type=script&lang=ts"
export * from "./ListeColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__